import styled from '@emotion/styled'

import { Spacing } from '../../../../../../enums/spacing'

export const ButtonWrapper = styled.span`
  button {
    padding-inline: ${Spacing.S8};
  }
`
